import React, {Component, PropTypes} from 'react'
import {LargeTableLogo} from './logos/logo_large'
import {Dropdown} from './dropdown'

export class NavBar extends Component {

  static propTypes = {
    user: PropTypes.object,
    white: PropTypes.bool,
    signOut: PropTypes.func
  }

  render () {
    const {user, white} = this.props
    let className = 'navbar'
    if (white) className += ' navbar--white'

    return (
      <div className={className}>
        <div className='navbar__left'>
          <a href='/'>
            <LargeTableLogo className='table-header__logo' white={white}/>
          </a>
        </div>
        {user ? this.renderSignedIn() : this.renderSignedOut()}
      </div>
    )
  }

  renderSignedOut () {
    const {white} = this.props
    let buttonClass = 'navbar__link button'
    if (white) buttonClass += '--white'

    return (
      <div className='navbar__right'>
        <a href='/app/signin' className='navbar__link'>Sign In</a>
        <a href="/app/signup" className={buttonClass}>Sign Up</a>
      </div>
    )
  }

  renderSignedIn () {
    const {user} = this.props

    return (
      <div className='navbar__right'>
        <div
          className='avatar--xs'
          style={{backgroundImage: user.avatarUrl && 'url('+user.avatarUrl+')'}}
        />
        <Dropdown className='navbar__dropdown' trigger={this.renderDropdownTrigger()}>
          <ul>
            <a href={`/u/${user.handle || user.id}`}>
              <li><span className='icon-profile'/> My Profile</li>
            </a>
            <a href={`/app/tables/all`}>
              <li><span className='icon-table-logo'/> My Tables</li>
            </a>
            <a href={`/user/settings`}>
              <li><span className='icon-gear'/> Settings</li>
            </a>
            <a href={`/app/people/invite`}>
              <li><span className='icon-add-person'/> Invite</li>
            </a>
            <a href={`/faq`}>
              <li><span className='icon-faq'/> FAQ</li>
            </a>
            <a href={`/legal/terms-and-conditions`}>
              <li><span className='icon-legal'/> Legal</li>
            </a>
            <a onClick={this.props.signOut} href={``}>
              <li><span className='icon-leave'/> Sign Out</li>
            </a>
          </ul>
          </Dropdown>
      </div>
    )
  }

  renderDropdownTrigger () {
    const {user} = this.props
    return (
      <span className='navbar__link navbar__menu-trigger'>
        {user.name} <span className='icon-arrow-down'/>
      </span>
    )
  }
}
